import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { AxiosError } from 'axios';

import { useCustomToast } from 'hooks';
import { fiscalizationF2 } from 'modules/_common/api';

export const useMutationFiscalizationF2 = () => {
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(fiscalizationF2, {
    onSuccess: () => successToast(t('Fiscalization 2.0 successfully completed')),
    onError: (error: AxiosError) => {
      const errorMessage = error.response?.data as { ErrorDescription: string };
      errorToast(errorMessage?.ErrorDescription);
    },
  });
};
